import { render, staticRenderFns } from "./IconCalendar.vue?vue&type=template&id=83ddbc82"
import script from "./IconCalendar.vue?vue&type=script&lang=js"
export * from "./IconCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports